export default "__VITE_ASSET__DsvesbJK__"